import PropTypes from "prop-types"
import { isNull } from "lodash"
import { Dialog, DialogTitle, DialogActions, DialogContent, Button, Alert } from "@mui/material"
import { PERMISSIONED_TOKEN } from "helpers/shapes"

import "./style.scss"

export default function RollTokenDialog({ showDialog, token, onSubmit, onClose }) {
  return showDialog && token && <Dialog className="modules_tokens_components_roll-token-dialog" open={!isNull(token)} onClose={onClose}>
    <DialogContent>
      <DialogTitle>
        Roll Token
      </DialogTitle>
      <Alert className="roll-token-warning" severity="warning">
        <div>Rolling a token will maintain the same token name and ID, but generate a new token secret. This will invalidate the previous secret.</div>
        <div><strong>Are you sure you want to roll {token.name}?</strong></div>
      </Alert>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={() => onSubmit(token)} color="primary" autoFocus>
          Roll Token
        </Button>
      </DialogActions>
    </DialogContent>
  </Dialog>
}

RollTokenDialog.propTypes = {
  showDialog: PropTypes.bool,
  token: PERMISSIONED_TOKEN,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}
